export const LOGGER_LEVEL = {
  INFO: "info",
  ERROR: "error",
};
